import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';
import * as React from 'react';
import {CSSProperties} from 'react';

export class ScaleModel
{
    @Property<ABoolean>({
        title: 'Scale enabled',
        tip: 'Scale enabled',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isEnabled:ABoolean;

    @Property<ABoolean>({
        title: 'Uniform Scale enabled',
        tip: 'Uniform Scale enabled',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isUniform:ABoolean;

    @Property<ANumber>({
        title: 'Scale',
        tip: `Scale`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    scale:ANumber;

    @Property<ANumber>({
        title: 'Scale X',
        tip: `Scale X`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    scaleX:ANumber;

    @Property<ANumber>({
        title: 'Scale Y',
        tip: `Scale Y`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    scaleY:ANumber;

    @Property<ANumber>({
        title: 'Scale Z',
        tip: `Scale Z`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    scaleZ:ANumber;

    public constructor(isEnabled:ABoolean,
                       isUniform:ABoolean,
                       scale:ANumber,
                       scaleX:ANumber,
                       scaleY:ANumber,
                       scaleZ:ANumber)
    {
        this.isEnabled = isEnabled;
        this.isUniform = isUniform;
        this.scale = scale;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        this.scaleZ = scaleZ;
    }

    public static default():ScaleModel
    {
        return new ScaleModel(
            ABoolean.false(),
            ABoolean.true(),
            ANumber.fromNumber(1),
            ANumber.fromNumber(1),
            ANumber.fromNumber(1),
            ANumber.fromNumber(1)
        );
    }

    public toCss(style:CSSProperties = {}):CSSProperties
    {
        if( this.isEnabled && this.isEnabled.value )
        {
            const scaleProps:Array<string> = [];
            const scaleX:number = this.isUniform.value ? this.scale.value : this.scaleX.value;
            const scaleY:number = this.isUniform.value ? this.scale.value : this.scaleY.value;

            if( scaleX !== 1 || scaleY !== 1 )
                scaleProps.push(`scale(${scaleX}, ${scaleY})`);

            if( this.scaleZ && this.scaleZ.value !== 1 )
                scaleProps.push(`scaleZ(${this.scaleZ.value})`);

            if( scaleProps.length > 0 )
            {
                let transform:string = style.transform
                    ? `${style.transform} ${scaleProps.join(' ')}`
                    : scaleProps.join(' ');

                return {
                    transform
                };
            }
        }

        return null;
    }
}
